'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

import './MaintenanceBanner.scss';
import UserStore from '../../stores/UserStore';
import { getConfig } from '../../utils/Env';

export default class MaintenanceBanner extends Component {
    static contextTypes = {
        location: PropTypes.object,
    }

    constructor(props) {
        super(props);

        this.state = {
            drawer: false,
            user: UserStore.getUser(),
            dismissed: false,
        };
    }

    componentDidMount = () => {
        UserStore.addChangeListener(this.onUserStoreChange);
        setTimeout(() => this.setState({drawer: true}));
    }

    componentWillUnmount = () => {
        UserStore.removeChangeListener(this.onUserStoreChange);
    }

    onUserStoreChange = () => {
        this.setState({user: UserStore.getUser()});
    }

    closeModal = () => {
        this.setState({drawer: false}, () => {
            setTimeout(() => {
                this.setState({dismissed: true});
            }, 350);
        });
    }

    render = () => {
        const showMaintenenceBanner = getConfig('show_maintenance_banner');
        
        if (showMaintenenceBanner !== 'true') {
            return <span />;
        }

        const { drawer, user, dismissed } = this.state;
        const { location } = this.context;

        if (!user || dismissed) {
            return <span />;
        }

        if (location && location.pathname.includes('/new-account')) {
            return <span />;
        }

        const todayET = new Date().toLocaleDateString('en-US', { timeZone: 'America/New_York' });
        const isMaintenanceDay = todayET === '5/28/2026';

        return (
            <div className="maintenance-banner" data-drawer={drawer}>
                <div className="inner-container">
                    <p>
                        {isMaintenanceDay ? (
                            <><strong>TODAY:</strong> EatLove will be down from <strong>11 PM to 6 AM ET for a major update.</strong></>
                        ) : (
                            <>Scheduled Maintenance: EatLove will be down <strong>May 28, 11 PM to 6 AM ET</strong> for a major update.</>
                        )}
                    </p>
                    <button className="close-btn" onClick={this.closeModal} aria-label="Close">
                        <i className="icon-close-x" />
                    </button>
                </div>
            </div>
        );
    }
}
